import React, { useState, useEffect } from 'react';
import { collection, getDocs, query, where, limit } from 'firebase/firestore';
import { db } from '../firebase';
import { FaSearch } from 'react-icons/fa';
import { UserItem } from '../components/UserItem';

export default function Users() {
  const [users, setUsers] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  // Fetch all users
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setIsLoading(true);
        const usersRef = collection(db, 'users');
        let usersQuery;
        
        if (searchQuery.trim()) {
          // Search by username (prefix matching)
          const searchTerm = searchQuery.toLowerCase();
          usersQuery = query(
            usersRef,
            where('username', '>=', searchTerm),
            where('username', '<=', searchTerm + '\uf8ff'),
            limit(20)
          );
        } else {
          // Default query for initial load
          usersQuery = query(usersRef, limit(50));
        }

        const querySnapshot = await getDocs(usersQuery);
        const usersData = querySnapshot.docs.map(doc => doc.id);
        setUsers(usersData);
      } catch (error) {
        console.error('Error fetching users:', error);
        setUsers([]); // Reset users on error
      } finally {
        setIsLoading(false);
      }
    };

    // Debounce the search to prevent excessive queries
    const debounceTimer = setTimeout(fetchUsers, 300);
    
    // Cleanup function
    return () => clearTimeout(debounceTimer);
  }, [searchQuery]);

  return (
    <div className="bg-black min-h-screen">
      {/* Sticky Search Bar */}
      <div className="sticky top-0 z-10 bg-black bg-opacity-90 border-b border-gray-800 p-4">
        <div className="relative max-w-xl mx-auto">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <FaSearch className="text-gray-500" />
          </div>
          <input
            type="text"
            placeholder="Search users by username..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full bg-gray-900 border border-gray-700 text-white pl-10 pr-4 py-2 rounded-full focus:outline-none focus:border-[#FF1493]"
            aria-label="Search users by username"
          />
        </div>
      </div>

      {/* Users List */}
      <div className="pb-20">
        {isLoading ? (
          // Loading skeleton
          <div className="space-y-4">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="flex items-center py-4 px-4">
                <div className="w-12 h-12 rounded-full bg-gray-700 animate-pulse mr-3"></div>
                <div className="flex-1">
                  <div className="h-4 w-24 bg-gray-700 rounded animate-pulse mb-1"></div>
                  <div className="h-3 w-16 bg-gray-700 rounded animate-pulse"></div>
                </div>
                <div className="h-8 w-20 bg-gray-700 rounded-full animate-pulse"></div>
              </div>
            ))}
          </div>
        ) : users.length > 0 ? (
          // Render user list
          users.map((userId) => (
            <UserItem key={userId} userId={userId} />
          ))
        ) : (
          // Empty state
          <div className="text-center py-10">
            <p className="text-gray-500">
              {searchQuery.trim() ? "No users found" : "No users available"}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}